exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-wrapper {\n  position: relative; }\n\n.input-icon {\n  position: absolute;\n  color: black;\n  margin-top: 1.1em;\n  font-size: 14px;\n  display: -ms-flexbox;\n  display: flex;\n  width: 2%;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  padding-right: 5px;\n  margin-left: 95%;\n  padding-bottom: 30px; }\n\n.fas {\n  margin-right: 5px;\n  cursor: pointer; }\n\n.none-click {\n  pointer-events: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/validate-vin/validate-vin.component.scss
// module id = 1935
// module chunks = 66